import React from 'react';
import { LucideIcon } from 'lucide-react';

interface StatCardProps {
    title: string;
    value: string | number;
    sublabel: string;
    SubIcon: LucideIcon;
    MainIcon: LucideIcon;
    colorBase: string;       // e.g. '#ff6a00'
    colorRgba: string;       // e.g. 'rgba(255, 106, 0, 0.1)'
    loading: boolean;
}

export const StatCard: React.FC<StatCardProps> = ({
    title,
    value,
    sublabel,
    SubIcon,
    MainIcon,
    colorBase,
    colorRgba,
    loading
}) => {
    return (
        <div style={{
            position: 'relative',
            overflow: 'hidden',
            padding: '16px', // Menor padding
            background: 'var(--glass-bg)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            border: 'var(--glass-border)',
            borderRadius: 'var(--radius)',
            transition: 'all 0.3s ease',
            cursor: 'default',
        }}
            className="glass-card stat-card-hover"
        >
            {/* Background Icon Watermark */}
            <div style={{ position: 'absolute', top: -5, right: -5, opacity: 0.05, transform: 'rotate(-10deg)', pointerEvents: 'none' }}>
                <MainIcon size={80} color={colorBase} />
            </div>

            <div style={{ position: 'relative', zIndex: 1, display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{
                    width: '40px',
                    height: '40px',
                    background: colorRgba,
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: `0 4px 15px ${colorRgba}`,
                    flexShrink: 0
                }}>
                    <MainIcon size={20} color={colorBase} />
                </div>

                <div>
                    <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginBottom: '4px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                        {title}
                    </div>

                    {loading ? (
                        <div className="shimmer-loading" style={{ height: '28px', width: '100px', borderRadius: '6px', marginBottom: '4px' }}></div>
                    ) : (
                        <div style={{ fontSize: '24px', fontWeight: 700, color: '#fff', marginBottom: '4px', lineHeight: 1 }}>
                            {value}
                        </div>
                    )}

                    <div style={{ fontSize: '12px', color: colorBase, display: 'flex', alignItems: 'center', gap: '4px', fontWeight: 500 }}>
                        <SubIcon size={12} />
                        {sublabel}
                    </div>
                </div>
            </div>
        </div>
    );
};
